import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import useStepClickHandler from '../hooks/useStepClickHandler';
import { getStepIconColor } from '../helpers/stepHelpers';

const StepMobile = ({
	isComplete,
	title,
	titleSideContent,
	showStepDivider = true,
	route,
	enabled
}) => {
	const labels = useLabels();
	const onClickHandler = useStepClickHandler(route, title);
	const dividerClass = showStepDivider ? 'border-bottom' : '';

	const iconColor = getStepIconColor(enabled, isComplete);

	return (
		<>
			<button
				className={`d-flex flex-row align-items-center ddc-font-size-base ${dividerClass} py-3 btn-unstyled`}
				onClick={enabled ? onClickHandler : undefined}
				type="button"
				aria-label={
					enabled
						? `${title}, ${
								isComplete
									? labels.get('COMPLETE')
									: labels.get('INCOMPLETE')
						  }`
						: `${title} (not available)`
				}
				aria-disabled={!enabled}
				tabIndex={enabled ? 0 : -1}
				style={{
					opacity: !enabled ? 0.5 : 1,
					cursor: !enabled ? 'not-allowed' : 'pointer'
				}}
			>
				<span
					className="text-decoration-underline text-link text-link-muted"
					style={{
						textDecoration: !enabled ? 'none' : 'underline'
					}}
				>
					{title}
				</span>
				<div className="ml-auto d-flex align-items-center ddc-font-size-base">
					{titleSideContent && (
						<div className="d-inline-block">{titleSideContent}</div>
					)}
					<i
						className="ddc-icon-circle-check ddc-icon d-inline-block ml-3"
						style={{
							fontSize: '30px',
							color: iconColor
						}}
						aria-hidden="true"
					/>
				</div>
			</button>
		</>
	);
};

StepMobile.propTypes = {
	isComplete: PropTypes.bool,
	title: PropTypes.string.isRequired,
	titleSideContent: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	]),
	showStepDivider: PropTypes.bool,
	route: PropTypes.string,
	enabled: PropTypes.bool
};

export default StepMobile;
